import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';

export const PATH_CLOSING_PORTAL = '/closing-portal';
const PATH_CLOSING_PORTAL_LOAN_DETAIL = '/closing-portal/loans/:applicationId';
export const PATH_CLOSING_PORTAL_LOGIN = '/closing-portal-login';

export const getClosingPortalLoanDetailPath = applicationId =>
  PATH_CLOSING_PORTAL_LOAN_DETAIL.replace(':applicationId', applicationId);

const routesConfig = {
  settings: {
    layout: {
      config: {
        toolbar: {
          display: false,
        },
        navbar: {
          display: false,
        },
        footer: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: PATH_CLOSING_PORTAL_LOGIN,
      component: lazyWithRetry(() => import('app/pages/closingPortal/ClosingPortalLogin')),
      exact: true,
      isGuestOnly: true,
      pageCode: PAGE_CODES.CLOSING_PORTAL_LOGIN,
    },
    {
      path: PATH_CLOSING_PORTAL_LOAN_DETAIL,
      component: lazyWithRetry(() => import('app/pages/closingPortal/LoanView')),
      exact: true,
      pageCode: PAGE_CODES.CLOSING_PORTAL,
    },
    {
      path: PATH_CLOSING_PORTAL,
      component: lazyWithRetry(() => import('app/pages/closingPortal/ClosingPortal')),
      exact: true,
      pageCode: PAGE_CODES.CLOSING_PORTAL,
    },
  ],
};

export default routesConfig;
